document.addEventListener('DOMContentLoaded', function () {

    // Filter sistemi (orijinal FAQs class'ından korundu)
    const faqsComponent = document.querySelector('faqs-item') || document.querySelector('[data-faqs-component]');

    // Tüm accordion header'larını bul
    const allHeaders = document.querySelectorAll('.faqs-item .card-header');

    allHeaders.forEach(function (header) {
        header.addEventListener('click', function () {
            const content = document.getElementById(
                header.getAttribute('data-target').replace('#', '')
            );
            const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

            // Tüm diğerlerini kapat
            allHeaders.forEach(function (otherHeader) {
                if (otherHeader === header) return;
                const otherId = otherHeader.getAttribute('data-target').replace('#', '');
                const otherContent = document.getElementById(otherId);
                if (otherContent) {
                    otherContent.style.maxHeight = null;
                    otherHeader.classList.remove('collapsed');
                    otherHeader.setAttribute('aria-expanded', 'false');
                }
            });

            // Tıklanana toggle uygula
            if (isOpen) {
                content.style.maxHeight = null;
                header.classList.remove('collapsed');
                header.setAttribute('aria-expanded', 'false');
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                header.classList.add('collapsed');
                header.setAttribute('aria-expanded', 'true');
            }
        });
    });

    // Filter dropdown — null guard ile korundu
    const filter = document.getElementById('haloFAQsFilter');
    if (filter) {
        const filterToggle = filter.querySelector('[data-faqs-filter]');
        const filterDropdown = filter.querySelector('.faqs-filterDropdown-menu');
        const filterDropdownArrow = filterToggle ? filterToggle.querySelector('[data-dropdown-arrow]') : null;

        if (filterToggle && filterDropdown) {
            filterToggle.addEventListener('click', function () {
                filterDropdown.classList.toggle('is-show');
                if (filterDropdownArrow) filterDropdownArrow.classList.toggle('active');
            });

            filterDropdown.querySelectorAll('.text').forEach(function (btn) {
                btn.addEventListener('click', function (event) {
                    const li = event.target.closest('li');
                    if (li.classList.contains('is-active')) return;

                    const filterValue = li.getAttribute('data-value');
                    filterToggle.querySelector('.text').innerText = event.target.innerText;

                    filterDropdown.querySelectorAll('li').forEach(el => el.classList.remove('is-active'));
                    li.classList.add('is-active');

                    document.querySelectorAll('.faqs-paragraph').forEach(function (el) {
                        if (!filterValue || el.getAttribute('id') == filterValue) {
                            el.classList.remove('is-hidden', 'is-active');
                            if (filterValue) el.classList.add('is-active');
                        } else {
                            el.classList.remove('is-active');
                            el.classList.add('is-hidden');
                        }
                    });

                    filterDropdown.classList.remove('is-show');
                    if (filterDropdownArrow) filterDropdownArrow.classList.remove('active');
                });
            });

            // Dışarı tıklayınca kapat
            document.body.addEventListener('click', function (event) {
                if (event.target.closest('[data-faqs-filter]') != null) return;
                if (filterDropdown.classList.contains('is-show')) {
                    filterDropdown.classList.remove('is-show');
                    if (filterDropdownArrow) filterDropdownArrow.classList.remove('active');
                }
            });
        }
    }
});
